import {
  maxLength10,
  maxLength6,
  maxLength4,
  required,
  noDigits,
  number,
  trimError,
  onlyLettersAndHyphen,
  noHyphenStartOrEnd,
  onlyDigits,
  onlyLettersAndNumberAndHyphen,
  maxLength80,
  maxLength50,
  onlyLetters,
  trimNoSpecStartOrEnd,
  onlyHouse,
} from '../utils/validation';
import DTO from './DTO';
import FilterTemplatePage from '../modules/FilterTemplate/components/FilterTemplatePage';

class FilterTemplateDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'search',
        type: String,
        labelKey: 'search',
      },
      {
        name: 'id',
        type: String,
        labelKey: 'filter.template.causer_id',
      },
      {
        name: 'causer_id',
        type: String,
        labelKey: 'filter.template.causer_id',
      },
      {
        name: 'name',
        type: String,
        labelKey: 'filter.template.name',
      },
      {
        name: 'page',
        type: String,
        labelKey: 'filter.template.page',
      },
      {
        name: 'is_active',
        type: String,
        labelKey: 'filter.template.is_active',
      },
      {
        name: 'created_at',
        type: String,
        labelKey: 'filter.template.created_at',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default FilterTemplateDTO;
